import { render, staticRenderFns } from "./TiposDeInversion.vue?vue&type=template&id=5ebc240a&scoped=true&"
import script from "./TiposDeInversion.vue?vue&type=script&lang=js&"
export * from "./TiposDeInversion.vue?vue&type=script&lang=js&"
import style0 from "./TiposDeInversion.vue?vue&type=style&index=0&id=5ebc240a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebc240a",
  null
  
)

export default component.exports